import { SiteHeader } from '@/components/layout/SiteHeader';
import { SiteFooter } from '@/components/layout/SiteFooter';
import { ScrollProgressBar } from '@/components/landing/motion';
import { HeroSection, TrustStrip } from '@/components/landing/Hero';
import { JpDeepMoat } from '@/components/landing/JpDeepMoat';
import { HybridRagExplainer } from '@/components/landing/HybridRag';
import { AgentsGrid, ConnectorsGrid } from '@/components/landing/AgentsConnectors';
import { ComparisonMatrix } from '@/components/landing/ComparisonMatrix';
import { FaqSection } from '@/components/landing/Faq';
import { SecuritySection, PricingTeaser, ClosingCta } from '@/components/landing/SecurityPricingClosing';

/**
 * Marketing landing page. Thin composition of section components under
 * components/landing/* — each section concentrates one idea with one tasteful
 * scroll-reveal animation (see motion.tsx), tuned for JP B2B gravitas and
 * `prefers-reduced-motion`. Bilingual (EN/JP) via the landing content module.
 */
export function LandingPage() {
  return (
    <div className="min-h-screen paper-archive">
      <ScrollProgressBar />
      <SiteHeader />
      <main>
        <HeroSection />
        <TrustStrip />
        <JpDeepMoat />
        <HybridRagExplainer />
        <AgentsGrid />
        <ConnectorsGrid />
        <ComparisonMatrix />
        <FaqSection />
        <SecuritySection />
        <PricingTeaser />
        <ClosingCta />
      </main>
      <SiteFooter />
    </div>
  );
}
